<template>
  <Dialog
    class="pg-dialog__wrapper"
    :customClass="customClass"
    :visible="visible"
    :title="props.title"
    :width="props.width"
    :fullscreen="props.fullscreen"
    :modal="props.modal"
    :closeOnClickModal="props.closeOnClickModal"
    :closeOnPressEscape="props.closeOnPressEscape"
    :showClose="props.showClose"
    :beforeClose="props.beforeClose"
    :top="props.top"
    @close="onClose"
    @closed="onClosed"
  >
    <template v-if="$slots.title" v-slot:title>
      <slot name="title"></slot>
    </template>
    <template v-slot:default>
      <slot>
        <span class="pg-dialog__body-default" v-html="props.message"></span>
      </slot>
    </template>
    <template v-if="props.showFooter" v-slot:footer>
      <slot name="footer">
        <Button
          style="min-width: 120px"
          round
          size="medium"
          :loading="cacelLoading"
          @click="btnClick()"
          v-if="props.cacelText"
          >{{ props.cacelText }}</Button
        >
        <Button
          style="min-width: 120px"
          type="primary"
          round
          size="medium"
          :loading="secoundConfirmLoading"
          @click="btnClick('secoundConfirm')"
          v-if="props.secoundConfirmText"
          >{{ props.secoundConfirmText }}</Button
        >
        <Button
          style="min-width: 120px"
          type="primary"
          round
          size="medium"
          :loading="confirmLoading"
          @click="btnClick('confirm')"
          v-if="props.confirmText"
          >{{ props.confirmText }}</Button
        >
      </slot>
    </template>
  </Dialog>
</template>
<script setup>
import { Dialog, Button } from 'element-ui'
import { ref, shallowReactive, computed, getCurrentInstance } from 'vue'

//可通过配置的props
const props = shallowReactive({
  customClass: '',
  title: '提示',
  beforeClose: null,
  closed: null,
  message: null,
  width: '340px',
  fullscreen: false,
  modal: true,
  closeOnClickModal: true,
  closeOnPressEscape: true,
  showClose: true,
  close: null, //该属性不允许配置
  showFooter: true,
  cacelText: '取 消',
  confirmText: '确 认',
  secoundConfirmText: null,
  top: '',
})
const visible = ref(false)
const customClass = computed(() => `pg-dialog ${props.customClass ?? ''}`)

const { proxy } = getCurrentInstance()

const close = () => {
  //清楚数组中的引用
  props.close?.()
  proxy.$destroy(true)
  proxy.$el.parentNode.removeChild(proxy.$el)
}
const onClosed = () => {
  //执行动画完成后的回调
  props?.closed?.()
  close()
}
const onClose = () => {
  visible.value = false
  cacelLoading.value = false
  confirmLoading.value = false
  secoundConfirmLoading.value = false
}
const cacelLoading = ref(false)
const confirmLoading = ref(false)
const secoundConfirmLoading = ref(false)
//按钮事件   type无值时表示关闭，为confirm时表示点击确认
const btnClick = (type) => {
  if (type === 'secoundConfirm') {
    secoundConfirmLoading.value = true
  } else if (type === 'confirm') {
    confirmLoading.value = true
  } else {
    cacelLoading.value = true
  }
  if (props.beforeClose) {
    props.beforeClose(onClose, type)
  } else {
    onClose()
  }
}
const show = (options) => {
  Object.keys(options).forEach((option) => (props[option] = options[option]))
  visible.value = true
}

//暴漏的方法
defineExpose({
  show,
  onClose,
})
</script>
<style lang="scss">
@import '../style/dialog.scss';
</style>
